import { useDispatch } from 'react-redux';
import A from './ActionCreators';
import Id from './IdFactory';
import { FIGURE_PANELS } from './RecordTypes';


export default function CreateMicroscopyFigureButton({template, setTargetDirectoryOfNewFigurePanel}){
  const dispatch = useDispatch();


  return (
    <button action={"acceptFigurePanelSettings"} disabled={!template} onClick={() => {
        let _id = Id();


      setTargetDirectoryOfNewFigurePanel(false);

        //setTargetDirectoryOfNewFigurePanel(false);
      let itemCreationArgs = {
          type:FIGURE_PANELS,
          figurePanelType:'microscopy',
          _id,
          args:{
            compactTemplate:template,
          },
          onSuccess:[
            A.setCellsValue({
              "figurePanelId":_id,
              "cells":[[2,1]],
              "value":{
              "valueType":"crop",
              "regions":{"main":null},
              "localTemplateId":"initTemplate",
              "expandable":true, 
              imageIdsByChannel:{} 
            }}),
            A.setSelectedFigurePanelContext({
              context:{
                _id,
                figurePanelId:_id
              }
            })
          ]
        }


        dispatch(A.createItem(itemCreationArgs))
      }} class="btn btn-primary">
        Create Figure
      </button>
  )
}
